import React, { Component } from 'react'
import BannerWeek from '../BannerWeek/BannerWeek';
import ResultsOfDay from '../ResultsOfDay/ResultsOfDay';
import { normalizeHour } from '../../utils/util'

export default class WeeklyCalendar extends Component {
    constructor(props) {
        super(props)

        this.state = {
            daySelected: 0,
            timeFromTxt: 0,
            timeOfTxt: 0,
            timeFrom: 0,
            timeOf: 0
        }
    }

    normalizeHour = (hh) => {
        let res = 0
        res = Number(hh.substring(0, hh.lastIndexOf(":"))) * 60
        res += Number(hh.substring(hh.lastIndexOf(":") + 1, hh.length))
        return res
    }
    componentDidMount() {
        this.initList()
    }

    initList = () => {
        const { weekList, setDaySelected } = this.props
        let timeFromTxt = "07:00"
        let timeOfTxt = "24:00"
        let timeFrom = this.normalizeHour(timeFromTxt)
        let timeOf = this.normalizeHour(timeOfTxt)
        let daySelected = 0
        weekList.currentWeek.daysOfWeek.map((day, index) => {
            if (day.active) {
                daySelected = index
                if (this.props.setDaySelected) setDaySelected(index)
            }
        })
        this.setState({
            daySelected,
            timeFromTxt,
            timeOfTxt,
            timeFrom,
            timeOf
        })
        
    }

    callbackDay = (index) => {
        const { setDaySelected } = this.props
        let daySelected = index
        this.setState({
            daySelected
        })
        if (setDaySelected) setDaySelected(index)
    }

    callbackHour = (timeTxt, timeType) => {
        let time = this.normalizeHour(timeTxt)
        if ( timeType==="timeFrom" ){
            this.setState({
                timeFromTxt : timeTxt,
                timeFrom : time
            })
        }else{
            this.setState({
            timeOfTxt : timeTxt,
            timeOf : time
            })
        }
    }

    resultsListFiltered = () => {
        const { daySelected, timeOf, timeFrom } = this.state
        const { resultsList } = this.props
        let resultsListFiltered = {
            activityAllDay: resultsList.results[daySelected].activityAllDay  && resultsList.results[daySelected].activityAllDay != "" ? [] : undefined,
            coursesOfDay: resultsList.results[daySelected].coursesOfDay && resultsList.results[daySelected].coursesOfDay != "" ? [] : undefined
        }
        
        if (resultsList.results[daySelected].activityAllDay != undefined && resultsList.results[daySelected].activityAllDay != ""){
            resultsList.results[daySelected].activityAllDay.map((elm, index) => {
                // if(((normalizeHour(elm.timeFrom) >= timeFrom) && (normalizeHour(elm.timeOf) <= timeOf))) {
                    resultsListFiltered.activityAllDay.push(elm)
                // }
            })
        }
            
        if (resultsList.results[daySelected].coursesOfDay != undefined && resultsList.results[daySelected].coursesOfDay != "" )
            resultsList.results[daySelected].coursesOfDay.map((elm, index) => {
                if(
                    ((normalizeHour(elm.timeFrom) >= timeFrom) && (normalizeHour(elm.timeOf) <= timeOf))
                ) {
                    resultsListFiltered.coursesOfDay.push(elm)
                }
            })



        // if (resultsListFiltered.activityAllDay!=undefined && resultsListFiltered.activityAllDay && resultsListFiltered.activityAllDay.length > 0){
        //     resultsListFiltered.activityAllDay = resultsListFiltered.activityAllDay.filter(function(activity, index, arr){
        //         return ((normalizeHour(activity.timeFrom) >= timeFrom) && (normalizeHour(activity.timeOf) <= timeOf));
        //     });
        // }
        
        // if (resultsListFiltered.coursesOfDay!=undefined && resultsListFiltered.coursesOfDay && resultsListFiltered.coursesOfDay.length > 0){
        //     resultsListFiltered.coursesOfDay = resultsListFiltered.coursesOfDay.filter(function(activity, index, arr){
        //         return ((normalizeHour(activity.timeFrom) >= timeFrom) && (normalizeHour(activity.timeOf) <= timeOf));
        //     });
        // }
        return resultsListFiltered
    }

    render() {

        const { weekList, resultsList, labels } = this.props
        const { daySelected, timeFromTxt, timeOfTxt} = this.state
        
        return (
            <div>
                <BannerWeek callbackChangeWeek={this.props.callbackChangeWeek} labels={labels} weekList={weekList} daySelected={daySelected} timeFromTxt={timeFromTxt} timeOfTxt={timeOfTxt} callbackDay={this.callbackDay} callbackHour={this.callbackHour}/>
                <ResultsOfDay labels={labels} resultsList={this.resultsListFiltered()} />
            </div>
        )
    }
}
